import { Injectable } from "@angular/core";
import { Select } from "@ngxs/store";
import { Observable } from "rxjs";
import { filter, first, map } from "rxjs/operators";
import { isDefined } from "src/utils/isDefined/isDefined";
import { AppState } from "../app.state"; // a service that sends the division with most child divisions. used  to set a default for for the division-filter-v2 component
import { EvirDivision } from "../models/shared.model";

@Injectable({
	providedIn: "root",
})
export class DefaultDivisionService {
	constructor() {}

	@Select(AppState.selectDivisions) divisionsFromState$: Observable<EvirDivision[]>;

	getDefaultDivision(): Observable<{ divisionId: string; count: number }> {
		return this.divisionsFromState$.pipe(
			filter(isDefined),
			first(),
			map(divs => {
				const tally = {};
				divs.forEach(div => {
					if (div.parentDivision) {
						if (!tally[div.parentDivision.id]) {
							tally[div.parentDivision.id] = 1;
						} else {
							tally[div.parentDivision.id] += 1;
						}
					}
				});

				let divWithMostChildren = { divisionId: null, count: 0 };

				Object.keys(tally).forEach(tKey => {
					if (tally[tKey] > divWithMostChildren.count) {
						divWithMostChildren = { divisionId: tKey, count: tally[tKey] };
					}
				});
				return divWithMostChildren;
			}),
		);
	}
}
